import { CompetitionsMatchCardSchema } from './CompetitionsMatchCard.styles';

export const competitionsMatchCardStyles: CompetitionsMatchCardSchema = {
  vsBoxWrapper: {
    position: 'relative',
    p: '1',
  },
  vsDivider: {
    borderColor: '#222',
    opacity: '0.2',
  },
  absoluteCenter: {
    px: '2',
    left: '2',
    ml: '1px',
    bg: 'alpha.500',
    fontWeight: 'normal',
    color: 'beta.500',
    fontFamily: 'Staatliches',
    fontSize: 'sm',
  },
  matchCardOverride: {
    mb: '2',
  },
  propositionButtonOverride: {
    w: '100%',
  },
  gridItem: {
    w: '100%',
  },
  flexWrapper: {
    alignItems: 'center',
  },
  flexText: {
    as: 'span',
    flex: '1',
    textAlign: 'left',
    fontWeight: 'normal',
    fontFamily: 'Staatliches',
    fontSize: 'sm',
    color: 'white',
  },
  gridWrapper: {
    gap: 2,
  },
  propositionButtonOverrideSecondary: {
    w: ['50px', '100px'],
    px: ['0', null, 'inherit'],
  },
  gridItemTextNoProposition: {
    w: ['50px', '100px'],
    h: 'full',
    minH: '10',
    textAlign: 'center',
    color: 'white',
    fontFamily: 'Staatliches',
    textShadow: '0px 2px 3px rgba(0, 0, 0, 0.30)',
    fontWeight: 'normal',
    fontSize: 'sm',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'base',
    border: '1px',
    borderColor: 'blackAlpha.300',
  },
  flexAwayTeam: {
    alignItems: 'center',
  },
  flexAwayTeamText: {
    flex: '1',
    textAlign: 'left',
    fontFamily: 'Staatliches',
    fontWeight: 'normal',
    fontSize: 'sm',
    color: 'white',
  },
};
